import { Department } from 'model/Department';

/**
 * Recursively sets the blocked property on all departments in a tree
 * @returns New array with blocked property set on all nodes
 */
export const blockDepartmentTree = (
  departments: Department[],
  shouldBlock: boolean
): Department[] => {
  return departments.map((department) => blockDepartmentNode(department, shouldBlock));
};

/**
 * Recursively sets the blocked property on a single department node and all its children
 */
const blockDepartmentNode = (department: Department, shouldBlock: boolean): Department => ({
  ...department,
  blocked: shouldBlock,
  children: department.children.map((child) => blockDepartmentNode(child, shouldBlock)),
});
